import {FormArray, FormControl, Validators} from '@angular/forms';
import {FormFieldComment} from '../comment/comment.model';


export enum ControlType {
  BOOLEAN = 0,
  RADIO = 1,
  MULTI = 2,
  TEXT = 3,
  INTEGER = 4,
  DECIMAL = 5,
  DEVICES = 6,
  DROPDOWN = 7,
  DATETIME = 8,
  // DURATION = 9,
  /** a calculated number: values[0] is the formula */
  EXPRESSION = 10,
  //PICTURE = 11,
  //TIMESTAMP = 12,
  DATE = 13,
  /** a calculated text: values[0] is the base64 JSON of a TableFieldCondition */
  CONDITION = 14,
  DATERANGE = 15,
  //DATETIME= 16 removed

}



export class ServiceFormItem {
  name: string;
  type: ControlType;
  renderTag: string;
  description: string;
  required: boolean;
  sort?: number;
  values?: string[];
  /** RADIO/DROPDOWN: JSON {"<option>": <number>}, the options' values in formulas */
  valueMap?: string | null;
  /** at most one comment per field — see FormFieldComment */
  comment?: FormFieldComment;

  constructor(name?: string,
              type?: ControlType,
              tag?: string,
              description?: string,
              required?: boolean,
              sort?: number,
              values?: string[],
              comment?: FormFieldComment) {
    this.name = name;
    this.type = type;
    this.renderTag = tag;
    this.description = description;
    this.required = required;
    this.sort = sort;
    this.values = values && [...values];
    this.comment = comment ?? null;
  }

  toMap(item: ServiceFormItem): Map<string, unknown> {
    const map = new Map<string, unknown>();
    map.set('name', item.name);
    map.set('type', item.type);
    map.set('renderTag', item.renderTag);
    map.set('description', item.description);
    map.set('required', item.required ?? false);
    map.set('sort', item.sort ?? 0);
    if (item.values?.length > 0) {
      const values = [];
      item.values.forEach((v) => {
        values.push(v);
      });
      map.set('values', values);
    }
    if (item.valueMap) {
      map.set('valueMap', item.valueMap);
    }
    if (item.comment) {
      const comment = new FormFieldComment(item.comment);
      map.set('comment', comment.toMap(comment));
    }
    return map;
  }
}

export class ServiceItemForm {
  name = new FormControl();
  type = new FormControl();
  renderTag = new FormControl();
  description = new FormControl();
  required = new FormControl(true);
  sort = new FormControl();
  values = new FormArray([]);
  valueMap = new FormControl<string | null>(null);
  comment = new FormControl<FormFieldComment | null>(null);

  constructor(
    item: ServiceFormItem,
  ) {
    if (item.name) {
      this.name.setValue(item.name);
    }
    if (item.type) {
      this.type.setValue(item.type);
    }
    if (item.renderTag) {
      this.renderTag.setValue(item.renderTag);
    }
    if (item.required !== undefined) {
      this.required.setValue(item.required);
    }
    if (item.description !== undefined) {
      this.description.setValue(item.description);
    }
    if (item.sort !== undefined) {
      this.sort.setValue(item.sort);
    }
    this.type.setValue(item.type);
    this.valueMap.setValue(item.valueMap ?? null);
    this.comment.setValue(
      item.comment
        ? FormFieldComment.fromMap(item.comment as unknown as Record<string, unknown>)
        : null,
    );

    this.name.setValidators([Validators.required]);
    this.name.updateValueAndValidity();
    this.renderTag.setValidators([Validators.required]);
    this.renderTag.updateValueAndValidity();
    this.type.setValidators([Validators.required]);
    this.type.updateValueAndValidity();
    this.required.setValidators([Validators.required]);
    this.required.updateValueAndValidity();

    if (item.values !== undefined && item.values.length > 0 && item.values[0] !== '') {
      item.values.forEach(i => {
        this.values.push(new FormControl(i));
      });
      this.values.setValidators(Validators.required);
    }
  }
}
